<template>
	<div class="user-setting lh1">
		<div class="user-setting-title">基本信息</div>
		<div class="user-detail flex">
			<div class="user-avatar ovh"><img :src="userInfo.icon" v-df-avatar alt="" class="vam w100" /></div>
			<div class="detail-inner flex-1">
				<div class="detail-row flex" v-show="0">
					<span class="label">昵称:</span>
					<span class="flex-1 value">{{ userInfo.realname }}</span>
				</div>
				<div class="detail-row flex">
					<span class="label">账号:</span>
					<span class="flex-1 value">{{ userInfo.username }}</span>
				</div>
				<div class="detail-row flex">
					<span class="label">就读年级:</span>
					<div class="flex-1 value flex">
						<span class="value-inner">{{ currGrade.short_name || currGrade.name }}</span>
						<span class="ctrl csp" @click="ctrls('grades')">修改</span>
					</div>
				</div>
				<div class="detail-row flex">
					<span class="label">会员类型:</span>
					<div class="flex-1 value vip-type" :class="{ ovh: vipList.length }">
						<template v-if="vipList.length">
							<div class="vip-row flex aic" v-for="(row, i) in vipList" :key="i">
								<div class="vip-col flex aic" :class="'vip-col-' + col.prop" v-for="(col, j) in vipCols" :key="j">
									<i class="mine-ico" :class="col.ico" v-show="col.ico"></i>
									<span @click="col.onclick && col.onclick(row)" :class="{ 'ctrl csp': col.onclick }" class="vip-col-inner">
										{{ typeof col.format === 'function' ? col.format(row[col.prop], row, col) : row[col.prop] }}
									</span>
								</div>
							</div>
						</template>
						<template v-else>
							<span class="value-inner">您还不是会员</span>
							<span class="ctrl csp open-vip" @click="ShowVip()">开通会员</span>
						</template>
					</div>
				</div>
			</div>
		</div>
		<div class="user-setting-title">安全设置</div>
		<div class="user-bind-list ovh">
			<div class="bind-row" v-for="(row, i) in bindList">
				<div class="bind-col flex aic w100">
					<div class="bind-label">{{ row.label }}</div>
					<div class="bind-value">
						<input class="password-input-text" type="password" value="******" v-show="row.prop === 'password' && userInfo.is_password === 1" readonly />
						<span v-show="userInfo.is_password !== 1 || row.prop !== 'password'">{{ userInfo[row.prop] ? userInfo[row.showProp || row.prop] : row.text }}</span>
					</div>
					<div class="bind-ctrl">
						<span class="ctrl csp" @click="row.onclick(row.prop)">{{ userInfo[row.prop] ? row.ctrl1 : row.ctrl }}</span>
					</div>
				</div>
			</div>
		</div>
		<modal-default :value="!!modalType">
			<div class="ctrl-modal por">
				<div class="circle ovh poa w100"></div>
				<div class="por zi1 tac">
					<div class="ctrl-title">{{ ctrlTitle }}</div>
					<div class="ctrl-content mlr-auto" :class="modalType">
						<div v-show="modalType === 'delete'" class="flex-col aic">
							<div class="tips lh1">确定要注销帐号吗？</div>
							<!-- <div class="inner">注销账户将不再享受我们提供的服务，<span class="red">请联系微信客服申请注销</span>，我们将会在48小时内完成审核。</div>
              <div class="kf-qr-code qr-code">
                <img :src="kfInfo.customer_code" alt="" class="vat w100 h100">
              </div>
              <div class="qr-code-tips lh1">客服微信</div> -->
							<div class="df-input phone-input ovh w100"><i-input placeholder="请输入手机号" readonly v-model="form.phone"></i-input></div>
							<div class="df-input code-input ovh flex aic" :class="{ 'can-click': codeStatus }">
								<i-input
									maxlength="6"
									:readonly="!form.verifycode_id"
									placeholder="请输入验证码"
									class="flex-1"
									v-model="form.verifycode"
									@on-keyup="changeInput('verifycode')"
								></i-input>
								<div class="send-code-btn csp tal"><countdown @starting="sendCode" @ending="countdownEnd"></countdown></div>
							</div>
							<div class="submit csp w100" @click="logoff">确定</div>
						</div>
						<div v-show="modalType === 'unionid'" class="flex-col aic">
							<template v-if="userInfo.unionid">
								<div class="tips lh1">解绑后，将无法使用微信账号快捷登录</div>
								<div class="qr-code wx-login-qr-code"><wx-img not-follow @is-use="modalType = ''" :to="unBindWxTo" :size="180" v-if="modalType === 'unionid'"></wx-img></div>
							</template>
							<template v-else>
								<div class="tips lh1">打开微信扫一扫授权绑定</div>
								<div class="qr-code wx-login-qr-code"><wx-img not-follow @is-use="modalType = ''" :to="bindWxTo" :size="180" v-if="modalType === 'unionid'"></wx-img></div>
							</template>
						</div>
						<div v-show="modalType === 'password'" class="flex-col" ref="inner">
							<div class="df-input phone-input ovh"><i-input placeholder="请输入手机号" readonly v-model="form.phone"></i-input></div>
							<div class="df-input code-input ovh flex aic" :class="{ 'can-click': codeStatus }">
								<i-input
									maxlength="6"
									:readonly="!form.verifycode_id"
									placeholder="请输入验证码"
									class="flex-1"
									v-model="form.verifycode"
									@on-keyup="changeInput('verifycode')"
								></i-input>
								<div class="send-code-btn csp tal"><countdown @starting="sendCode" @ending="countdownEnd"></countdown></div>
							</div>
							<div class="df-input pwd-input ovh">
								<i-input placeholder="请设置6~12位密码" :type="showPwd ? '' : 'password'" v-model="form.password" maxlength="12" @on-keyup="changeInput('password')">
									<i slot="suffix" class="login-icon" :class="showPwd ? 'ico-12' : 'ico-11'" @click="showPwd = !showPwd"></i>
								</i-input>
							</div>
							<div class="submit csp" @click="changePwd">确定</div>
						</div>
						<div v-show="modalType === 'phone'" class="flex-col por">
							<div class="step-list flex jcb aic w100 unselect lh1">
								<template v-for="(item, ind) in stepList">
									<div v-show="ind" class="step-line flex-1" :key="ind"></div>
									<div class="step-item por" :key="ind" :class="{ 'step-act': form.currStepInd === ind }">
										<div class="inner bsb">{{ ind + 1 }}</div>
										<div class="step-name wsnw abs-c">{{ item }}</div>
									</div>
								</template>
							</div>
							<template v-if="form.currStepInd !== 2">
								<div class="old-phone tal" v-show="form.currStepInd === 0">当前手机号码: {{ form.phone }}</div>
								<div v-show="form.currStepInd === 1" class="df-input phone-input ovh"><i-input placeholder="请输入手机号" v-model="form.phone"></i-input></div>
								<div class="phone-err err-tip tal" v-if="form.errMsg">{{ form.errMsg }}</div>
								<div class="df-input code-input ovh flex aic" :key="form.currStepInd" :class="{ 'can-click': codeStatus }">
									<i-input
										maxlength="6"
										placeholder="请输入验证码"
										:readonly="!form.verifycode_id"
										class="flex-1"
										v-model="form.verifycode"
										@on-keyup="changeInput('verifycode')"
									></i-input>
									<div class="send-code-btn csp tal"><countdown @starting="sendCode" @ending="countdownEnd"></countdown></div>
								</div>
								<div class="code-err err-tip tal" v-show="form.codeErr">{{ form.codeErr }}</div>
							</template>
							<template v-else>
								<div class="success-tip flex aic jcc">
									<i class="modal-ico success img"></i>
									<span>手机号码修改完成</span>
								</div>
								<div class="success-tip1">修改手机后可使用新手机号登录</div>
							</template>
							<div :class="{ 'no-to-next': notNext }" class="submit csp phone-next" @click="phoneNext">{{ form.currStepInd < stepList.length - 1 ? '下一步' : '我知道了' }}</div>
							<div class="code-tip abs-c lh1 wsnw flex aic" v-show="form.currStepInd !== 2">
								<poptip-item placement="right" class="kf-poptip" show-slot :item="kfObj"><span class="kf-btn csp" slot="show">没有收到验证码？请联系客服</span></poptip-item>
							</div>
						</div>
					</div>
					<div class="ctrl-close poa modal-ico close csp" @click="modalType = ''"></div>
				</div>
			</div>
		</modal-default>
	</div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';

export default {
	name: 'UserSetting',
	computed: {
		...mapGetters(['userInfo', 'allGrades', 'kfInfo', 'newApiToken', 'oldToken', 'currAudio', 'currUserVip']),
		bindWxTo() {
			let url = this.$route.fullPath;
			url += url.indexOf('?') >= 0 ? '&' : '?';
			url += 'isBindWx=1';
			return url;
		},
		notNext() {
			return (this.form.currStepInd === 0 && !this.form.verifycode) || (this.form.currStepInd === 1 && (!this.form.verifycode || !this.form.phone));
		},
		unBindWxTo() {
			let url = this.$route.fullPath;
			url += url.indexOf('?') >= 0 ? '&' : '?';
			url += 'isUnbindWx=1';
			return url;
		},
		currGrade(val) {
			return this.allGrades ? this.allGrades.find(e => e.id === this.userInfo.nianji_id) || {} : {};
		},
		ctrlTitle() {
			this.form = {
				phone: this.userInfo.phone,
				verifycode: '',
				verifycode_id: '',
				password: '',
				currStepInd: this.form.currStepInd === 2 && this.modalType ? 2 : 0,
				errMsg: '',
				codeErr: ''
			};
			this.codeStatus = true;

			let { modalType, userInfo } = this;
			let title = '';
			switch (modalType) {
				case 'delete':
					title = '注销账号';
					break;
				case 'phone':
					title = '修改手机号';
					break;
				case 'password':
					title = '密码设置';
					break;
				case 'unionid':
					title = userInfo.unionid ? '解绑微信' : '绑定微信';
					break;
			}
			return title;
		}
	},
	watch: {
		userInfo(val) {}
	},
	data() {
		return {
			kfObj: { type: 'kf' },

			modalType: '',
			stepList: ['验证身份', '绑定新手机', '操作完成'],
			showPwd: false,
			codeStatus: true,
			form: {},
			vipList: [],
			bindList: [
				{ label: '手机', prop: 'phone', text: '未绑定', ctrl: '绑定', ctrl1: '更换', onclick: this.ctrls },
				{
					label: '微信',
					showProp: 'nickname',
					prop: 'unionid',
					text: '未绑定',
					ctrl: '绑定',
					ctrl1: '解绑',
					onclick: this.ctrls
				},
				{ label: '登录密码', prop: 'password', text: '未设置', ctrl: '设置', ctrl1: '更换', onclick: this.ctrls },
				{ label: '账号注销', prop: 'delete', text: '', ctrl: '注销', ctrl1: '注销', onclick: this.ctrls }
			],
			vipCols: [
				{ prop: 'goods_name', ico: 'vip1' },
				{ prop: 'end_time', format: v => (v ? this.Tools.formatDate(v, '到期时间: Y年M月D日') : '') },
				{ prop: 'product_id', format: v => '续费', onclick: this.vipCb }
			]
		};
	},
	created() {
		this.getVipList();
	},
	methods: {
		...mapMutations(['setNewApiToken', 'setUserInfo', 'setOldToken', 'setCurrAudio', 'setCurrUserVip', 'setCurrGrade']),
		changeInput(name) {
			let { form } = this;
			let value = form[name];
			//限制输入中文
			form[name] = value.replace(/[\u4E00-\u9FA5 ]/g, '');
		},
		unbind() {
			this.http
				.unbind({
					uid: this.userInfo.uid,
					unionid: this.userInfo.unionid,
					...this.Product
				})
				.then(res => {
					this.ShowToast('解绑成功！');
					this.GetUserInfoApi(this.userInfo.uid);
				})
				.catch(this.$err)
				.finally(() => {
					this.modalType = '';
				});
		},

		async sendCode(next, unlock) {
			let { form } = this;
			if (!form.phone) {
				unlock();
				return this.ShowToast('请输入手机号！');
			} else if (!this.Tools.isPhone(form.phone)) {
				unlock();
				return this.ShowToast('请输入正确手机号！');
			} else if (!this.codeStatus) {
				return;
			}
			this.codeStatus = false;
			this.http
				.getPhoneCode({
					phone: form.phone,
					sign_type: 1
				})
				.then(res => {
					form.verifycode_id = res.verifycode_id;
					next();
				})
				.catch(err => {
					unlock();
					this.codeStatus = true;
					this.ShowToast(err.msg);
				});
		},

		countdownEnd(vm) {
			this.codeStatus = true;
		},

		changePwd() {
			let { form } = this;
			let tvm = this.$refs.inner;
			tvm = tvm[0] || tvm;
			if (!form.phone) {
				return this.ShowToast('请输入手机号！', tvm);
			} else if (!this.Tools.isPhone(form.phone)) {
				return this.ShowToast('请输入正确手机号！', tvm);
			} else if (!form.verifycode) {
				return this.ShowToast('请输入验证码！', tvm);
			} else if (!form.password) {
				return this.ShowToast('请输入密码！', tvm);
			}

			this.http
				.updatePassword({
					...form,
					uid: this.userInfo.uid
				})
				.then(res => {
					this.ShowToast('修改成功！');
					setTimeout(() => {
						this.modalType = '';
					}, 1000);
				})
				.catch(this.$err);
		},
		logoff() {
			let { form } = this;
			if (!form.verifycode) {
				return this.ShowToast('请输入验证码！');
			}
			this.http
				.NEWCancelUser({
					...form,
					uid: this.userInfo.uid,
					...this.Product
				})
				.then(res => {
					this.ShowToast('注销成功！');
					setTimeout(async () => {
						this.modalType = '';
						localStorage.clear();
						sessionStorage.clear();
						await this.setUserInfo({});
						await this.setNewApiToken('');
						await this.setOldToken('');
						await this.setCurrAudio('');
						await this.setCurrUserVip({});
						if (this.currGrade && +this.currGrade.pid === 5) {
							await this.setCurrGrade({ id: 8, name: '小学一年级', short_name: '一年级', pid: '2' });
						}
						if (JSON.stringify(this.userInfo) === '{}' && !this.newApiToken && !this.oldToken && !this.currAudio && JSON.stringify(this.currUserVip) === '{}') {
							location.reload();
						}
					}, 1000);
				})
				.catch(this.$err);
		},
		ctrls(type) {
			switch (type) {
				case 'grades':
					this.SelectGrade();
					break;
				default:
					this.modalType = type;
			}
		},
		vipCb(row) {
			this.ShowVip();
		},
		getVipList() {
			if (!this.userInfo.uid) return;
			this.http
				.NEWMyVip({
					uid: this.userInfo.uid,
					limits: 1000
				})
				.then(res => {
					this.vipList = res.list;
				})
				.catch(this.$err);
		},
		phoneNext() {
			let { form } = this;
			if (this.notNext) {
				if (this.stepList.length - 1) {
				} else {
					this.modalType = '';
				}
				return;
			}
			if (form.currStepInd !== 2 && !form.verifycode_id) {
				return this.ShowToast('请先获取验证码！');
			}
			switch (form.currStepInd) {
				case 0:
					// 验证旧手机
					this.http
						.testPhoneCode({
							verifycode_id: form.verifycode_id,
							verifycode: form.verifycode
						})
						.then(res => {
							form.currStepInd = 1;
							this.codeStatus = true;
							form.old_verifycode = form.verifycode;
							form.old_verifycode_id = form.verifycode_id;
							form.verifycode = '';
							form.verifycode_id = '';
							form.phone = '';
							form.codeErr = '';
						})
						.catch(err => {
							form.codeErr = err.msg || '网络错误！';
						});
					break;
				case 1:
					// 验证新手机
					this.http
						.bindNewPhone({
							uid: this.userInfo.uid,
							...form,
							new_phone: form.phone
						})
						.then(res => {
							form.currStepInd = 2;
							this.GetUserInfoApi(this.userInfo.uid);
						})
						.catch(err => {
							form.errMsg = err.msg || '网络错误！';
						});
					break;
				case 2:
					// 完成
					this.GetUserInfoApi(this.userInfo.uid);
					this.modalType = '';
					break;
			}
		}
	}
};
</script>

<style scoped lang="less">
@import '../../assets/less/function';

.password-input-text {
	background-color: transparent;
}

.modal-ico {
	.spirit(url(../../assets/images/user_icons.png));
	&.close {
		&:after {
			width: 28px;
			height: 27px;
			background-position: -196px -50px;
		}
	}
	&.success {
		margin-right: 12px;
		&:after {
			width: 32px;
			height: 32px;
			background-position: -120px -91px;
		}
	}
}

.login-icon {
	.spirit(url(../../assets/images/1_login_icon.png));
	&.ico-1 {
		&:after {
			width: 28px;
			height: 28px;
			background-position: -11px -16px;
		}
	}
	&.ico-2 {
		margin-right: 10px;
		&:after {
			width: 18px;
			height: 18px;
			background-position: -45px -21px;
		}
	}
	&.ico-3 {
		margin-right: 10px;
		&:after {
			width: 18px;
			height: 18px;
			background-position: -69px -21px;
		}
	}
	&.ico-5 {
		margin: 0 16px 0 109px;
		&:after {
			width: 30px;
			height: 24px;
			background-position: -174px -17px;
		}
	}
	&.ico-6 {
		margin: 0 21px 0 115px;
		&:after {
			width: 19px;
			height: 27px;
			background-position: -211px -16px;
		}
	}
	&.ico-7 {
		&:after {
			width: 22px;
			height: 18px;
			background-position: -15px -55px;
		}
	}
	&.ico-8 {
		&:after {
			width: 16px;
			height: 10px;
			background-position: -46px -59px;
		}
	}
	&.ico-9 {
		&:after {
			width: 16px;
			height: 10px;
			background-position: -71px -59px;
		}
	}
	&.ico-11 {
		line-height: 40px;
		&:after {
			width: 18px;
			height: 11px;
			background-position: -115px -59px;
		}
	}
	&.ico-12 {
		line-height: 40px;
		&:after {
			width: 18px;
			height: 16px;
			background-position: -145px -55px;
		}
	}
	&.ico-13 {
		top: 8px;
		right: 8px;
		&:after {
			width: 23px;
			height: 24px;
			background-position: -178px -52px;
		}
	}
}

.submit {
	margin: 42px 0 3px;
	line-height: 40px;
	font-size: 18px;
	color: #fff;
	background-color: #1177ff;
	border-radius: 8px;
	&:hover {
		background-color: #0066ed;
	}
}

.unbind-ctrls {
	padding: 0 22px;
	font-size: 14px;
	> :nth-child(n) {
		width: 120px;
		line-height: 34px;
		border: 1px solid #1177ff;
		color: #1177ff;
		border-radius: 36px;
	}
	.submit-cancel {
		background-color: #1177ff;
		color: #fff;
		&:hover {
			background-color: #0066ed;
		}
	}
}

.df-input {
	margin-top: 16px;
	background-color: #f5f7fb;
	border-radius: 8px;
	&:first-child {
		margin-top: 36px;
	}

	/deep/ .ivu-input {
		padding: 12px 16px;
		height: 40px;
		line-height: 1;
		box-sizing: border-box;
		color: #333f4e;
		border: 0;
		outline: 0;
		box-shadow: none;
		background-color: transparent;
		:-ms-input-placeholder {
			font-size: 14px;
			color: #999fa6;
		}
	}
	/deep/ .ivu-input-suffix {
		width: 36px;
		text-align: left;
	}
	/deep/ .ivu-input-with-suffix {
		padding-right: 48px;
	}
	.send-code-btn {
		padding-left: 12px;
		width: 98px;
		color: #1177ff;
		line-height: 1;
		border-left: 1px solid #1177ff;
	}
}

.ctrl- {
	&modal {
		width: 372px;
		min-height: 64px;
		background-color: #fff;
		border-radius: 8px;
		.circle {
			height: 64px;
			z-index: 0;
			border-radius: 8px;
			&:before {
				content: '';
				position: absolute;
				width: 509px;
				height: 125px;
				top: -61px;
				left: 50%;
				background-color: #1177ff;
				border-radius: 50%;
				transform: translateX(-50%);
			}
		}
	}
	&title {
		font-size: 18px;
		color: #fff;
		font-weight: bold;
		line-height: 64px;
	}
	&content {
		padding-bottom: 33px;
		width: 308px;
		font-size: 12px;
		color: #999fa6;
		line-height: 20px;
		&.delete {
			width: 265px;
		}
		.red {
			color: #ff5e53;
		}
		.tips {
			margin: 18px 0 17px;
			font-size: 16px;
			color: #666f7a;
		}
		.qr-code {
			margin: 12px 0;
			width: 136px;
			height: 136px;
			box-shadow: 0 5px 11px 0 rgba(0, 15, 34, 0.08);
			&.wx-login-qr-code {
				margin: 10px 0 13px;
				width: 180px;
				height: 180px;
			}
		}

		.step-list {
			margin: 17px 0 55px;
			padding: 0 23px;
			.step-name {
				top: 38px;
			}
			.step-item {
				margin: 0 3px;
				padding: 3px;
				border: 1px solid transparent;
				border-radius: 50%;
				.inner {
					width: 26px;
					height: 26px;
					line-height: 26px;
					font-size: 14px;
					color: #fff;
					border-radius: 50%;
					background-color: #1177ff;
				}
			}
			.step-line {
				height: 1px;
				background-color: #1177ff;
			}
			.step-act {
				border-color: #1177ff;
				color: #1177ff;
				~ .step-item {
					.inner {
						color: #1177ff;
						border: 1px dashed #1177ff;
						background-color: transparent;
					}
				}
				~ .step-line {
					background-color: #999fa6;
				}
			}
		}
		.old-phone {
			font-size: 14px;
			color: #333f4e;
		}
		.phone-next {
			border-radius: 40px;
			&.no-to-next {
				background-color: #92ccff;
			}
		}
		.err-tip {
			color: #ff2517;
			line-height: 33px;
			+ .code-input {
				margin-top: 5px;
			}
		}
		.code-tip {
			bottom: -20px;
		}
		.success-tip {
			margin: 23px 0 15px;
			font-size: 16px;
			color: #1177ff;
		}
		.success-tip1 {
			font-size: 14px;
		}
	}
	&close {
		top: 6px;
		right: 6px;
	}
}

.user-detail {
	margin-bottom: 64px;
}

.kf-btn {
	&:hover {
		color: #1177ff;
	}
}

/deep/ .kf-poptip {
	.ivu-poptip-body {
		padding: 0;
	}
}

.user-setting {
	padding: 32px 32px 97px;
	font-size: 14px;
	color: #999fa6;
	&-title {
		margin-bottom: 24px;
		font-size: 18px;
		color: #666f7a;
	}
	.user-avatar {
		margin-right: 32px;
		width: 120px;
		height: 120px;
		border-radius: 8px;
	}
	.detail-row {
		.vip-row {
			height: 40px;
			background-color: #fffbf5;
			&:nth-child(2n + 1) {
				background-color: #fff8ec;
			}
		}
		.vip-col {
			&:nth-child(2) {
				width: 231px;
				color: #999fa6;
			}
			&:first-child {
				width: 232px;
				padding-left: 15px;
				color: #b9732e;
			}
			&:last-child {
				flex: 1;
			}
			.mine-ico {
				&:after {
					margin-right: 10px;
					background-color: #ffc264;
				}
			}
		}
		.value {
			color: #333f4e;
		}
		.label {
			margin-right: 16px;
		}
		&:not(:last-child) {
			margin-bottom: 24px;
		}
	}

	.vip-type {
		max-width: 512px;
		font-size: 12px;
		border-radius: 4px;
	}
	.bind-value {
		color: #333f4e;
		width: 486px;
	}
	.bind-label {
		padding-left: 72px;
		width: 234px;
	}
	.user-bind-list {
		border-radius: 4px;
	}
	.bind-row {
		background-color: #fafcff;
		&:nth-child(2n-1) {
			background-color: #f5f7fb;
		}
	}
	.bind-col {
		height: 44px;
	}
	.ctrl {
		font-size: 12px;
		color: #1177ff;
		text-decoration: underline;
	}
	.value-inner {
		+ .ctrl {
			margin-left: 8px;
		}
		+ .open-vip {
			margin-left: 11px;
			padding: 3px 10px;
			font-size: 12px;
			color: #b9732e;
			font-weight: bold;
			border: 1px solid #b9732e;
			border-radius: 4px;
			text-decoration: unset;
		}
	}
}

.modal-default {
	z-index: 101;
}
</style>
